<template>
  <div>
    <div class="flex_center_bettwen dataCleaningFilter">
      <div class="flex_center_start dataCleaningFilter-in">
        <div class="cas_panel">
          <el-input
            type="text"
            key="filterConame"
            v-model="filterConame"
            clearable
            placeholder="Co. Name"
          >
            <i
              @click="getChildrenData(rowData)"
              class="el-input__icon el-icon-search"
              slot="suffix"
            >
            </i>
          </el-input>
        </div>
        <div class="cas_panel">
          <el-input
            type="text"
            v-model="filterLegalForm"
            clearable
            placeholder="Legal Form"
          >
            <i
              @click="getChildrenData(rowData)"
              class="el-input__icon el-icon-search"
              slot="suffix"
            >
            </i>
          </el-input>
        </div>
        <div class="cas_panel">
          <el-select
            style="width: 100%"
            clearable
            v-model="filterCountry"
            filterable
            :popper-append-to-body="false"
            placeholder="Country"
          >
            <el-option
              v-for="(item, index) in rowData.filterCountryOptions"
              :key="index"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="cas_panel">
          <el-select
            style="width: 100%"
            clearable
            v-model="filterStatus"
            filterable
            :popper-append-to-body="false"
            popper-class="new-search-select"
            placeholder="Select Status"
          >
            <el-option
              v-for="(item, index) in rowData.filterStatusOptions"
              :key="index"
              :label="item.key"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="cas_panel">
          <el-select
            style="width: 100%"
            clearable
            v-model="filterDQI"
            filterable
            :popper-append-to-body="false"
            popper-class="new-search-select"
            placeholder="Select DQI"
          >
            <el-option
              v-for="(item, index) in rowData.filterDQIOptions"
              :key="index"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="flex_center_start dataCleaningFilter-btns">
        <el-button
          type="primary"
          class="dataCleaningFilter-btn"
          :disabled="
            !rowData.selectedChildren ||
            rowData.selectedChildren.length == 0 ||
            aaaidSelected === 0
          "
          @click="batchUpdate"
        >
          Bulk Update
        </el-button>
        <!-- <el-button type="primary" class="dataCleaningFilter-btn"
          :disabled="
            !rowData.selectedChildren || rowData.selectedChildren.length == 0
          "
        >
          批量定位
        </el-button> -->
        <el-button
          type="primary"
          class="dataCleaningFilter-btn"
          @click="getChildrenData(rowData)"
        >
          <img
            src="@/assets/images/dataServices/dataCleaning-img/search.png"
            alt=""
          />
        </el-button>
      </div>
    </div>
    <div class="tree_table_box subtable-in" style="padding-top: 0px">
      <el-table
        :data="rowData.subData"
        border
        cell-class-name=""
        :key="rowData.aaaId"
        :row-key="getRowKey"
        max-height="400"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="companyName"
          label="Co. Name"
          align="left"
          width="300"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="companyCountry"
          label="Country"
          align="left"
          width="140"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="statusEn"
          label="Reg. Status"
          align="left"
          min-width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="isicCode"
          label="ISIC"
          align="center"
          min-width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column
          prop="regcapScopeEn"
          label="Reg. Capital"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <el-table-column
          prop="companyClassEn"
          label="Legal Form"
          align="left"
          min-width="130"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="failReason"
          label="Status"
          align="left"
          min-width="130"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tooltip
              effect="light"
              :content="scope.row.failReason"
              placement="top"
              v-if="scope.row.status == 5"
            >
              <span>{{ formatStatus(scope.row.status) }}</span>
            </el-tooltip>
            <span v-else>{{ formatStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="qcscore"
          label="DQI"
          align="right"
          width="60"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="dataUpdateTime"
          label="Update Time"
          align="right"
          min-width="130"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ formatDataUpdateTime(scope.row.dataUpdateTime) }}
          </template>
        </el-table-column>

        <el-table-column
          prop=""
          label=""
          width="280"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="flex_center dataClean-operate-box">
              <el-button
                type="text"
                class="dataClean-operate"
                :disabled="scope.row.status !== 1"
                @click="toDetailView(scope.row)"
              >
                View
              </el-button>
              <el-button
                type="text"
                class="dataClean-operate"
                :disabled="scope.row.status !== 1"
                @click="toUpdateDataCleaning(scope.row)"
              >
                Clean
              </el-button>
              <el-button
                type="text"
                class="dataClean-operate"
                :disabled="!scope.row.uploadTime"
                @click="toDownloadSingle(scope.row)"
              >
                Download
              </el-button>
              <el-button
                type="text"
                class="dataClean-operate"
                @click="toMatch(scope.row)"
              >
                Match
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- Online Matching 弹框 -->
    <SearchcompanyDialog
      :dialogVisible="onlineMatchingVisible"
      :currentRow="matchCurrentRow"
      @closeDialogOnlineMatch="closeDialogOnlineMatch"
    ></SearchcompanyDialog>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/components/page/index.vue";
import SearchcompanyDialog from "./dataCleaningSearchcompany.vue";

export default {
  mixins: [mixins1],
  components: {
    Page,
    SearchcompanyDialog,
  },
  props: {
    scopeRow: { type: Object, default: () => {} },
    currentParentIndex: { type: Number, default: 0 },
  },
  data() {
    return {
      rowData: [],
      filterConame: "",
      filterLegalForm: "",
      filterCountry: "",
      filterStatus: "",
      filterDQI: "",
      onlineMatchingVisible: false,
      matchCurrentRow: {},
      multipleSelection: [],
      aaaidSelected: [],
    };
  },
  watch: {
    scopeRow: {
      handler(newVal) {
        this.rowData = newVal;
        console.log(this.rowData);
        if (this.rowData.selectedChildren) {
          const aaaids = this.rowData.selectedChildren.reduce((acc, item) => {
            if (item.aaaId) {
              acc.push(item.aaaId);
            }
            return acc;
          }, []);
          console.log("当前选中的aaaid", aaaids);
          this.aaaidSelected = aaaids.length;
        }
      },
      immediate: true,
      deep: true, // 深度监听，可以监听对象内部属性的变化
    },
    filterConame(newVal) {
      this.rowData.filterConame = newVal;
    },
    filterLegalForm(newVal) {
      this.rowData.filterLegalForm = newVal;
    },
    filterCountry(newVal) {
      this.rowData.filterCountry = newVal;
    },
    filterStatus(newVal) {
      this.rowData.filterStatus = newVal;
    },
    filterDQI(newVal) {
      this.rowData.filterDQI = newVal;
    },
  },
  created() {},
  computed: {},
  methods: {
    getRowKey(row, index) {
      // 确保 row.aaaId 存在，防止报错
      const id = row.aaaId || "no_id";
      return `${id}_${row.id}`;
    },
    handleSelectionChange(selection) {
      console.log("subtanle选中的 ", selection);
      this.multipleSelection = selection;
      // 将选中项通过事件抛给父组件
      this.$emit("update-selection", selection);
    },
    formatStatus(status) {
      if (status === null || status === undefined) {
        return "Unknown";
      }
      switch (status) {
        case -1:
          return "Unknown";
        case 0:
          return "Unstarted";
        case 1:
          return "Success";
        case 2:
          return "Cleaning";
        case 3:
          return "Regenerated";
        case 4:
          return "Canceled";
        case 5:
          return "Failed";
        case 6:
          return "Processing";
        case 7:
          return "Matching";
        default:
          return "Unknown";
      }
    },

    formatDataUpdateTime(val) {
      if (!val) {
        return "";
      }
      return val.slice(0, 4);
    },
    formatCreateTime(val) {
      if (!val) {
        return "";
      }
      return val.replace("T", " ");
    },
    toDownloadSingle(row) {
      console.log("toDownloadSingleFn", row);
      this.$emit("toDownloadSingleFn", row);
    },
    toDetailView(row) {
      console.log("toDetailView", row);
      this.$emit("toDetailViewFn", row, this.rowData.subData);
    },
    toUpdateDataCleaning(row) {
      this.$emit("updateDataCleaning", row, this.rowData);
    },
    // 批量 download
    async batchUpdate() {
      this.$emit("batchUpdateDataCleaning", this.rowData);
    },
    getChildrenData(row) {
      this.$emit("getChildrenDataFn", row);
    },
    toMatch(row) {
      this.onlineMatchingVisible = true;
      this.matchCurrentRow = row;
      console.log("选中的二级", this.matchCurrentRow);
    },
    closeDialogOnlineMatch(msg) {
      this.onlineMatchingVisible = false;
      if (msg && msg == "refresh") {
        this.$emit("updateParentChildDataFn", this.rowData, this.currentParentIndex);
      }
    },
  },
};
</script>
<style scoped>
/* 二级table 筛选 */
.dataCleaningFilter {
  margin-bottom: 16px;
}
.dataCleaningFilter-in {
  flex: 1;
  gap: 0 10px;
  padding-right: 10px;
}
.dataCleaningFilter .cas_panel {
  width: 25%;
}
.dataCleaningFilter /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.dataCleaningFilter /deep/ .el-input .el-input__inner {
  padding-right: 48px;
}
.dataCleaningFilter /deep/ .el-input__suffix {
  right: 5px;
}
.dataCleaningFilter /deep/ .el-input__inner::placeholder {
  font-size: 16px !important;
  color: #999999 !important;
  /* font-family: Arial, Arial; */
}
.dataCleaningFilter-btns .el-button + .el-button {
  margin-left: 5px;
}
.dataCleaningFilter-btn {
  width: 100px !important;
  height: 40px !important;
  min-width: auto !important;
  min-height: 40px !important;
  font-size: 14px;
  padding: 0;
}
.dataCleaningFilter /deep/ .el-input__suffix-inner .el-icon-search {
  cursor: pointer;
}
.dataCleaningFilter /deep/ .el-input__suffix-inner .el-input__clear {
  margin-left: -20px;
}
.dataClean-operate {
  font-size: 16px;
  color: #b98b73;
  height: 15px;
  line-height: 15px;
  padding: 0 8px;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 0;
  background: none !important;
  text-decoration: none !important;
  margin: 0 !important;
}
.dataClean-operate:not(:last-child) {
  border-right: 1px solid #d3d3d3;
}
.dataClean-operate:first-of-type {
  padding-left: 0;
}
.dataClean-operate:last-of-type {
  padding-right: 0;
}
.dataClean-operate.is-disabled {
  color: #dfcec5;
  background: none;
}
.subtable-in /deep/ .el-table__empty-block {
  background-image: url("../../../assets/images/empty.png") !important;
  margin: 30px 0 !important;
  min-height: 140px !important;
  background-size: contain !important;
}
.subtable-in /deep/ .el-table__fixed-right {
  display: block !important;
  box-shadow: 0 0 10px rgb(0 0 0 / 12%) !important;
}
@media (max-width: 1920px) {
  .dataClean-operate,
  .dataCleaningFilter /deep/ .el-input__inner::placeholder {
    font-size: 16px !important;
  }
  .dataCleaningFilter /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .dataCleaningFilter-btn {
    height: 32px !important;
    min-height: 32px !important;
  }
}
@media (max-width: 1440px) {
  .dataClean-operate,
  .dataCleaningFilter /deep/ .el-input__inner::placeholder {
    font-size: 14px !important;
  }
  .dataCleaningFilter /deep/ .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
  .dataCleaningFilter-btn {
    height: 28px !important;
    min-height: 28px !important;
  }
}
</style>
